import {createRouter, createWebHistory} from "vue-router";
// import Dashboard from "../views/Dashboard.vue";
// import Tables from "../views/Tables.vue";
// import Billing from "../views/Billing.vue";
// import VirtualReality from "../views/VirtualReality.vue";
// import Profile from "../views/Profile.vue";
// import Signup from "../views/Signup.vue";
// import Signin from "../views/Signin.vue";
//
// import Custom from "../views/Custom.vue"

import Home from "../views/cert/Home"
import AlertDetails from "../views/cert/AlertDetails"
import AlertList from "../views/cert/AlertList"
import Contact from "@/views/cert/Contact";
import About from "@/views/cert/About";
import Advisories from "@/views/cert/Advisories";
import Resources from "@/views/cert/Resources";
import Tools from "@/views/cert/Tools";
import Legal from "@/views/cert/Legal";
import Guidelines from "@/views/cert/Guidelines";
import Search from "@/views/cert/Search";
import Keys from "@/views/cert/Keys";
import ReportIncident from "@/views/cert/ReportIncident";
import ReportVulnerability from "@/views/cert/ReportVulnerability";
import Services from "@/views/cert/Services";
import Subscribe from "@/views/cert/Subscribe";
import Unsubscribe from "@/views/cert/Unsubscribe";
import GuideIncident from "@/views/cert/GuideIncident";
import Phishing from "@/views/cert/articles/Phishing";
import Breach from "@/views/cert/articles/Breach";
import Ddos from "@/views/cert/articles/Ddos";
import Defacement from "@/views/cert/articles/Defacement";
import Malware from "@/views/cert/articles/Malware";
import Password from "@/views/cert/articles/Password";
import Rfc from "@/views/cert/Rfc";
import NotFound from "@/views/cert/NotFound";

const routes = [
    {
        path: "/",
        name: "/",
        // redirect: "/dashboard-default",
        redirect: "/home",
    },
    {
        path: "/home",
        name: "Home",
        component: Home,
    },
    {
        path: "/article/:type/:id",
        name: "Alert",
        component: AlertDetails,
    },
    {
        path: "/alerts",
        name: "Alerts",
        component: AlertList,
    },
    {
        path: "/contact",
        name: "Contact",
        component: Contact,
    }, {
        path: "/about",
        name: "About",
        component: About,
    }, {
        path: "/advisories",
        name: "Advisories",
        component: Advisories,
    },
    {
        path: "/resources",
        name: "Resources",
        component: Resources,
    },
    {
        path: "/tools",
        name: "Tools",
        component: Tools,
    },
    {
        path: "/legal",
        name: "Legal",
        component: Legal,
    },
    {
        path: "/guidelines",
        name: "Guidelines",
        component: Guidelines,
    },
    {
        path: "/search",
        name: "Search",
        component: Search,
    },
    {
        path: "/keys",
        name: "Keys",
        component: Keys,
    },
    {
        path: "/report-incident",
        name: "ReportIncident",
        component: ReportIncident,
    },
    {
        path: "/report-vulnerability",
        name: "ReportVulnerability",
        component: ReportVulnerability,
    }, {
        path: "/services",
        name: "Services",
        component: Services,
    }, {
        path: "/subscribe",
        name: "Subscribe",
        component: Subscribe,
    }, {
        path: "/unsubscribe/:param",
        name: "Unsubscribe",
        component: Unsubscribe,
    }, {
        path: "/guide/incident",
        name: "GuideIncident",
        component: GuideIncident,
    },
    {
        path: "/phishing",
        name: "Phishing",
        component: Phishing,
    },
    {
        path: "/breach",
        name: "Breach",
        component: Breach,
    },
    {
        path: "/ddos",
        name: "Ddos",
        component: Ddos,
    },
    {
        path: "/defacement",
        name: "Defacement",
        component: Defacement,
    }, {
        path: "/malware",
        name: "Malware",
        component: Malware,
    }, {
        path: "/password",
        name: "Password",
        component: Password,
    },{
        path: "/rfc",
        name: "Rfc",
        component: Rfc,
    },
    { path: "/:pathMatch(.*)*", component: NotFound }
];


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
    // eslint-disable-next-line no-unused-vars
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {selector: to.hash}
        }
        window.scrollTo(0, 0);
    }
});

export default router;


// {
//     path: "/dashboard-default",
//         name: "Dashboard",
//     component: Dashboard,
// },
// {
//     path: "/tables",
//         name: "Tables",
//     component: Tables,
// },
// {
//     path: "/billing",
//         name: "Billing",
//     component: Billing,
// },
// {
//     path: "/virtual-reality",
//         name: "Virtual Reality",
//     component: VirtualReality,
// },
// {
//     path: "/test",
//         name: "test component",
//     component: Custom,
// },
// {
//     path: "/profile",
//         name: "Profile",
//     component: Profile,
// },
// {
//     path: "/signin",
//         name: "Signin",
//     component: Signin,
// },
// {
//     path: "/signup",
//         name: "Signup",
//     component: Signup,
// },
